module.exports = __webpack_public_path__ + "static/media/p-content-3.79749d50.png";